module.exports = __webpack_public_path__ + "static/img/cysw05_02.8f1d10c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/cysw/cysw05_02.jpg
// module id = /CCh
// module chunks = 0